/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

export interface GeographyOptions {
  continents: { label: string; value: string; selected: boolean }[];
  countries: { label: string; value: string; selected: boolean }[];
}

/**
 * Sources location (continent/country autocomplete + lists) and
 * Sources Panels column.
 */
@Component({
  selector: 'app-filter-sources',
  templateUrl: './filter-sources.component.html',
  styleUrls: ['./filter-sources.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSourcesComponent {
  @Input() geography: GeographyOptions = { continents: [], countries: [] };
  @Input() panels: { label: string; value: string }[] = [];
  @Input() geographyControl: UntypedFormControl;
  @Input() panelsControl: UntypedFormControl;
  @Input() geographyForm: UntypedFormGroup;
  @Input() geographyGroupOptions: Observable<any>;

  @Output() search = new EventEmitter<{ name: string; type: string }>();
  @Output() toggleOption = new EventEmitter<any>();
}
